/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export function format(input: string, ...args: any[]) {
  return input.replace(/{(\d+)}/g, (match: string, index: number): string =>
    typeof args[index] !== 'undefined' ? args[index] : match
  );
}
